import { render, staticRenderFns } from "./InvoiceRecipientSelect.vue?vue&type=template&id=0408dd0f&lang=pug&"
import script from "./InvoiceRecipientSelect.vue?vue&type=script&lang=ts&"
export * from "./InvoiceRecipientSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports